import PubSub from "underpub-js";

var postSpotlight = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-PostSpotlight',
	};

	$.extend(true, this.options, options);

};

postSpotlight.prototype.init = function() {

	var self = this;

};

export default postSpotlight;
